import axios from 'axios';
import AuthService from "./AuthService";
export const BASE_URL = process.env.VUE_APP_BACKEND_HOST + "/api/v1";
const ApiService = {
    get(resource) {
        return axios.get(resource)
    },

    getWithAuth(resource) {
        const accessToken = AuthService.getAccessToken();
        return axios.get(BASE_URL + resource, {headers: {'Authorization': `Bearer ${accessToken}`}})
    },

    post(resource, data) {
        const accessToken = AuthService.getAccessToken();
        return axios.post(BASE_URL + resource, data, {headers: {'Authorization': `Bearer ${accessToken}`}});
    },

    put(resource, data) {
        const accessToken = AuthService.getAccessToken();
        return axios.put(BASE_URL + resource, data, {headers: {'Authorization': `Bearer ${accessToken}`}})
    },

    delete(resource) {
        const accessToken = AuthService.getAccessToken();
        return axios.delete(BASE_URL + resource, {headers: {'Authorization': `Bearer ${accessToken}`}})
    },
};
export default ApiService
